import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

export interface CommonPopupNotification {
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommonPopupService {
  private popupSubject = new Subject<CommonPopupNotification>();

  constructor(private translate: TranslateService) {}

  // Observable that components can subscribe to
  public popup$ = this.popupSubject.asObservable();

  // Method to be called by interceptor
  notifyPopup(notification: CommonPopupNotification) {
    this.popupSubject.next(notification);
  }

  // Method to be called by interceptor for 403 errors
  notifyForbiddenError(message?: string) {
    const notification: CommonPopupNotification = {
      title: this.translate.instant('COMMON.FORBIDDEN'),
      message: message || this.translate.instant('COMMON.MSG_FORBIDDEN_ACTION')
    };
    this.notifyPopup(notification);
  }

  // Method to be called by interceptor for 423 Locked errors
  notifyLockedError(title?: string, message?: string) {
    const notification: CommonPopupNotification = {
      title: title || this.translate.instant('COMMON.ACCOUNT_TEMPORARILY_LOCKED'),
      message: message || this.translate.instant('WALLET_SETTINGS.MSG_ACCOUNT_BLOCKED_ATTEMPTS')
    };
    this.notifyPopup(notification);
  }
}
